<template>
  <div class="card-form">
    <PageTable
      ref="table"
      :loading="loading"
      :tableData="tableData"
      :tablePage="page"
      @reload="reload"
      @checkbox-change="(e) => $emit('checkbox-change', e)"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageTable>
  </div>
</template>
<script>
import BaseTable from '@/mixins/base-table'
import PageHeader from './header.vue'
import PageTable from './table.vue'
export default {
  mixins: [BaseTable],
  components: { PageTable, PageHeader },
  props: {
    hxPurchaseCode: { type: String, default: '' },
  },
  data() {
    return { usePage: true }
  },
  methods: {
    getData(form) {
      if (!this.hxPurchaseCode) return
      this.loading = true
      this.$api
        .ecomHxFtyPurchaseDetailOptionsApi({
          ...form,
          ...this.page,
          hxPurchaseCode: this.hxPurchaseCode,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    clearCheckboxRow() {
      this.$refs.table.clearCheckboxRow()
    },
  },
}
</script>
